import {
  Button,
  Divider,
  Image,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { goToPage } from "../../../routes/coordinator";
import { JWTToken } from "../../../routes/privateRoute";
import jwt_decode from "jwt-decode";
import PermissionsAPI from "../../../services/permissionsAPI";
import { useSetRecoilState, useRecoilState } from "recoil";
import { permissions } from "../../../atoms/permissions";
import { customColors } from "../../../atoms/customColors";

interface IMenu {
  link: string;
  text: string;
  iconArrow?: any;
  image?: any;
  item: {}[];
  disabled: boolean;
}

export default function SideBarMenuItens(props: IMenu) {
  const navigate = useNavigate();
  const length = props.item.length;
  const [permited, setPermited] = useState<Array<{}>>([]);
  const [isNotEmpty, setIsNotEmpty] = useState(false);
  const [permissionsList, setPermissionsList] = useState<Array<{}>>([]);
  const colors = useRecoilState(customColors)[0];

  const token = window.localStorage.getItem("token");

  let jwtToken: JWTToken = {
    email: "",
    exp: 0,
    iat: 0,
    idCliente: "",
    idEmpresa: "",
    name: "",
    nbf: 0,
    primarysid: "",
    role: "",
    loginPermissoes: "",
  };
  let loginPermissoes: number[] = [];

  if (token && typeof token === "string" && token.includes(".")) {
    try {
      jwtToken = jwt_decode(token);
      if (jwtToken.loginPermissoes) {
        loginPermissoes = JSON.parse(jwtToken.loginPermissoes);
      }
    } catch (error) {
      // console.error("Error decoding JWT or parsing loginPermissoes:", error);
    }
  }

  const setPermsRecoil = useSetRecoilState(permissions);

  async function perms(id: any) {
    try {
      const response = await PermissionsAPI.getPermissions(id);
      setPermissionsList(response);
      setPermsRecoil(response);
      setIsNotEmpty(!(response.length > 0));
    } catch (error) {
      //console.log(error);
    }
  }

  useEffect(() => {
    if (permissionsList.length === 0 && !isNotEmpty) {
      perms(Number(jwtToken.idCliente));
    }
  }, [permissionsList, jwtToken.idCliente]);

  const goToPageIndex = (path: any) => {
    goToPage(navigate, path);
  };

  function temPermissao(
    userPerm: number | null,
    clientePerm: boolean,
    permArray: number[] = []
  ): boolean {
    if (!permArray.length || userPerm === null) {
      return clientePerm ?? false;
    }
    const permUser = permArray.includes(userPerm);
    const permCliente = clientePerm ?? false;
    return permUser && permCliente;
  }

  function isPermited(allPerms: any, perms: any) {
    let permissoes: any[] = [];
    if (
      perms.findIndex((perm: any) => perm.idPermissoes === 36) !== -1 &&
      perms.findIndex((perm: any) => perm.idPermissoes === 37) !== -1 &&
      perms.findIndex((perm: any) => perm.idPermissoes === 2) !== -1 &&
      perms.findIndex((perm: any) => perm.idPermissoes === 1) !== -1 &&
      perms.findIndex((perm: any) => perm.idPermissoes === 24) !== -1
    ) {
      permissoes = allPerms.filter((item: any) =>
        temPermissao(
          item.id,
          perms.some((perm: any) => perm.idPermissoes === item.id),
          loginPermissoes
        )
      );
      setPermited(permissoes);
    } else if (
      perms.findIndex((perm: any) => perm.idPermissoes === 1) !== -1 &&
      perms.findIndex((perm: any) => perm.idPermissoes === 24) === -1
    ) {
      permissoes = allPerms
        .filter((item: any) => item.id !== 24)
        .filter((item: any) =>
          temPermissao(
            item.id,
            perms.some((perm: any) => perm.idPermissoes === item.id),
            loginPermissoes
          )
        )
        .map((item: any) => item);
      setPermited(permissoes);
    } else {
      permissoes = allPerms
        .filter((item: any) => {
          const hasClientPerm =
            perms.findIndex(
              (perm: any) => perm.idPermissoes === item.id || -2 === item.id
            ) !== -1;
          return temPermissao(item.id, hasClientPerm, loginPermissoes);
        })
        .map((item: any) => item);

      const hasPermission36 = perms.some(
        (perm: any) => perm.idPermissoes === 36
      );
      const hasPermission37 = perms.some(
        (perm: any) => perm.idPermissoes === 37
      );
      const hasPermission2 = perms.some((perm: any) => perm.idPermissoes === 2);
      if (permissoes.some((item: any) => item.id === 36) && !hasPermission36) {
        permissoes = permissoes.filter((item: any) => item.id !== 36);
      }
      if (permissoes.some((item: any) => item.id === 37) && !hasPermission37) {
        permissoes = permissoes.filter((item: any) => item.id !== 37);
      }
      if (permissoes.some((item: any) => item.id === 2) && !hasPermission2) {
        permissoes = permissoes.filter((item: any) => item.id !== 2);
      }
      setPermited(permissoes);
    }
  }

  useEffect(() => {
    if (props.item && permissionsList.length > 0) {
      isPermited(props.item, permissionsList);
    }
  }, [permissionsList]);

  const seen = new Set();
  const uniquePermited = permited.filter((item) => {
    const key = Object.keys(item)[0];
    return seen.has(key) ? false : seen.add(key);
  });

  return (
    <Menu offset={[0, 0]} placement={"right"} autoSelect={false}>
      <MenuButton
        disabled={
          !props.disabled
            ? permited.length > 0
              ? false
              : true
            : props.disabled
        }
        textAlign={"left"}
        fontWeight={"bold"}
        px={"7"}
        _hover={{ bg: "#4B4B57", color: "blue.200", width: "99%" }}
        _active={{ bg: "none", color: "blue.200", width: "100%" }}
        bg={"none"}
        color={colors.WHITE}
        w={"100%"}
        borderRadius="none"
        as={Button}
        fontSize={"1vw"}
        leftIcon={
          <Image
            boxSize="1.6rem"
            src={props.image}
            alt="Icone"
            mr="10px"
            color={colors.YELLOWMONEDD}
          />
        }
        rightIcon={<props.iconArrow color={colors.YELLOWMONEDD} />}
        borderBottom={"1px solid white"}
      >
        <Text fontSize={"1rem"}>{props.text}</Text>
      </MenuButton>
      <MenuList
        zIndex={3}
        borderRadius={"0 12px 12px 0"}
        bgColor={colors.BLUEMONEDDBUTTONS}
        border={"none"}
        color={colors.WHITE}
        p={"1px 0 0 0"}
      >
        {uniquePermited &&
          uniquePermited.map((item: any, index: number) => {
            let objeto = Object.keys(item);
            let path: any = Object.values(item);
            return (
              <div key={index}>
                <MenuItem
                  key={item.id}
                  h="40px"
                  ml={"3px"}
                  _hover={{
                    bg: "none",
                    color: "white",
                    width: "100%",
                    borderLeft: "3px solid yellow",
                    marginLeft: "0",
                  }}
                  onClick={() => goToPageIndex(path[0])}
                >
                  {objeto[0]}
                </MenuItem>
                {uniquePermited.length - 1 === index ? (
                  <></>
                ) : (
                  <Divider size="1px" mt={"-1px"} key={index}></Divider>
                )}
              </div>
            );
          })}
      </MenuList>
    </Menu>
  );
}
